import React, { ReactNode } from 'react';

const GridWrapper = ({ children }: { children: ReactNode }) => {
  return <div className="grid w-full grid-cols-[742px_356px] h-full gap-x-[18px]">{children}</div>;
};
export default GridWrapper;
